import {
  Box,
  Center,
  Flex,
  Image,
  SimpleGrid,
  Text,
  Link,
  VStack,
} from "@chakra-ui/react";
import { Link as LinkRouter } from "react-router-dom";
import CardPlans from "./cardplans";
import LineSection from "../lineSection";
import Lang from "../../Lang";

export default function Footer() {
  return (
    <>
      <LineSection />

      <Box
        color='white'
      >
        <Center>
          <Box
            w={"8xl"}
            py={10}
          >
            <Text
              fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
              className="barlow-black"
              color={"gray.50"}
              mt={10}
              mb={{ base: 14, md: 16 }}
              pl={{ base: 6, md: 10 }}
              as={"h2"}
            >
              <Lang text="SOCIAL INITIATIVE PROGRAMS" />
            </Text>


            <SimpleGrid
              columns={{ base: 1, md: 3, lg: 3, xl: 3 }}
              spacing={10}
            >
              <CardPlans
                image="assets/AI-Teens.svg"
                texts="We help to acquire educational resources to develop programming, robotics or artificial intelligence classes or workshops with young people up to 17 years old."
                link="/AI-Teens"
              />

              <CardPlans
                image="assets/AI-Prof.svg"
                texts="Financial aid to students pursuing higher education in the fields of data science, artificial intelligence or robotics."
                link="/AI-Prof"
              />

              <CardPlans
                image="assets/AI-SmallBusiness.svg"
                texts="Support to small companies or entrepreneurship projects helping them to generate more value in their data thanks to the use of AI."
                link="/AI-SmallBusiness"
              />

            </SimpleGrid>

          </Box>
        </Center>
      </Box>

      <Box
        bg={"#ddeaf2"}
      >
        <Center
          pt={{ base: 10, md: 20, xl: 20 }}
        >

          <Box
            w={"8xl"}
          >
            <SimpleGrid
              columns={{ base: 1, md: 4, xl: 4 }}
            >
              <VStack
                align={"left"}
                spacing={{ base: "10px", md: "20px", xl: "20px" }}
                px={{ base: "20px", md: "20px", xl: "20px" }}
                py={{ base: 0, md: 2, xl: 2 }}
              >
                <Text
                  fontSize={{ base: "1em", md: "1.3em", xl: "1.5em" }}
                  className="barlow-black">
                  <Lang text="Go to" />
                </Text>
                <Center>
                  <LinkRouter to="https://appox.ai" target="_blank">
                    <Image
                      src="/assets/Appox_logo_01 1.svg"
                      h={20}
                      pb={{ base: "20px" }}
                    />
                  </LinkRouter>
                </Center>
              </VStack>

              <VStack
                align={"left"}
                spacing={{ base: "10px", md: "20px", xl: "20px" }}
                px={{ base: "20px", md: "20px", xl: "20px" }}
                py={{ base: 0, md: 2, xl: 2 }}
              >
                <Text
                  fontSize={{ base: "1em", md: "1.3em", xl: "1.5em" }}
                  className="barlow-black">
                  <Lang text="Support" />
                </Text>

                <Link href="/termsandconditions" style={{ "text-decoration": "none" }}>
                  <Text fontSize={{ base: "1em", md: "1.3em", xl: "1.2em" }}>
                    <Lang text="Terms and conditions" />
                  </Text>
                </Link>

                <Text fontSize={{ base: "1em", md: "1.3em", xl: "1.2em" }}>
                  <Lang text="Privacy policy" />
                </Text>
              </VStack>

              <VStack
                align={"left"}
                spacing={{ base: "10px", md: "20px", xl: "20px" }}
                px={{ base: "20px", md: "20px", xl: "20px" }}
                py={{ base: 8, md: 2, xl: 2 }}
              >
                <Text
                  fontSize={{ base: "1em", md: "1.3em", xl: "1.5em" }}
                  className="barlow-black">
                  <Lang text="Follow us" />
                </Text>

                <LinkRouter
                  to='https://www.linkedin.com/company/apox-ai'
                  target="_blank"
                >
                  <Flex
                    align={"center"}
                  >
                    <Image
                      src='assets/IN_icono 1.svg'
                      h={{ base: 5, md: 8 }}
                    />
                    <Text fontSize={{ base: "1em", md: "1.3em", xl: "1.2em" }}>
                      &nbsp; Linkedin
                    </Text>
                  </Flex>
                </LinkRouter>

                <LinkRouter
                  to='https://medium.com/@AppOX'
                  target="_blank" >
                  <Flex
                    align={"center"}
                  >
                    <Image
                      src='assets/Medium_Icono 1.svg'
                      h={{ base: 5, md: 8 }}
                    />
                    <Text fontSize={{ base: "1em", md: "1.3em", xl: "1.2em" }}>
                      &nbsp; Medium
                    </Text>
                  </Flex>
                </LinkRouter>

              </VStack>

              <VStack
                align={"left"}
                spacing={{ base: "10px", md: "20px", xl: "20px" }}
                px={{ base: "20px", md: "20px", xl: "20px" }}
                py={{ base: 0, md: 2, xl: 2 }}
              >
                <Text
                  fontSize={{ base: "1em", md: "1.3em", xl: "1.5em" }}
                  className="barlow-black"
                >
                  <Lang text="Contact us" />
                </Text>

                <Flex
                  align={"center"}
                >
                  <Image
                    src='assets/email_icono.svg'
                    h={{ base: 5, md: 8 }}
                  />
                  <Text
                    fontSize={{ base: "1em", md: "1.3em", xl: "1.2em" }}
                  >
                    &nbsp; socialinitiatives@appox.ai
                  </Text>
                </Flex>

                <Flex
                  align={"center"}
                >
                  <Image
                    src='assets/telephono_icon.svg'
                    h={{ base: 5, md: 8 }}
                  />
                  <Text
                    fontSize={{ base: "1em", md: "1.3em", xl: "1.2em" }}
                  >
                    &nbsp; +1 855-APPOX-GO
                  </Text>
                </Flex>

              </VStack>

            </SimpleGrid>
          </Box>
        </Center>
        <Center>
          <Text
            py={10}
            fontSize={{ base: "0.8em", md: "1em", xl: "1em" }}
          >
            2024 | <LinkRouter to="https://appox.ai" target="_blank"> AppOX</LinkRouter> - Quebec - <Lang text="Canada" /> &nbsp; | &nbsp;  <Lang text="All rigths reserved" /> </Text>
        </Center>

      </Box>

    </>

  );
}
